window.addEventListener('load', function () {
    fakeBelts();
    videoPlay();
    productHover();
    updateProductVariantPrices();
    updateCartPricesWithDiscounts();
    setTimeout(() => {
        if (typeof initCartPropertiesSimple === 'function') initCartPropertiesSimple();
    }, 500);
})

function productHover() {
    const products = document.querySelectorAll('.product-card');
    if (products.length > 0) {
        products.forEach(e => {
            e.addEventListener('mouseenter', function () {
                e.classList.add('hovered');
            })
            e.addEventListener('mouseleave', function () {
                e.classList.remove('hovered');
            })
        })
    }
}

Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
    get: function () {
        return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
    }
})

function videoPlay() {
    const block = document.querySelector('.template-product');
    if (block) {
        const videos = block.querySelectorAll('.main-video[img-id]');
        if (videos.length > 0) {
            videos.forEach(video => {
                video.addEventListener('click', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    const player = video.querySelector('video');
                    const button = video.querySelector('.pause-button');
                    if (player.playing) {
                        player.pause();
                        button.style.display = 'block';
                    } else {
                        player.play();
                        button.style.display = 'none';
                    }
                })
            })
        }
    }
}


function fakeBelts() {
    const block = document.querySelector('.template-product');
    if (block) {
        const message = block.querySelector('.fake-message');
        const selector = block.querySelector('#product_select');
        const fakeProperty = block.querySelector('.fake-property');
        if (message && selector) {
            selector.addEventListener('change', function (event) {
                let selected = selector.options ? selector.options[selector.selectedIndex] : selector.querySelector('[variant-option].active');
                if (!selected || !fakeProperty) return;
                let check = selected.dataset.showFake;
                if (check) {
                    message.style.display = 'block';
                    fakeProperty.value = selected.value || selected.textContent.trim();
                    // message.querySelector('span').innerHTML = selected.value
                } else {
                    message.style.display = 'none';
                    fakeProperty.value = null;
                }
            })
        }
    }
}

// Google reviews are provided by Appio; no per-visitor Places API requests.

//set your api key and location id in these two constants
// const apiKey = 'AIzaSyBOB_fBobPAc7CkdLgOyOH5i2XzkpAtenw';
// const locationId = 'ChIJI9XPY7I0xEcRCjRlUlnoK9Q';

// let map, service, infowindow;

// window.initMap = () => {
//     infowindow = new google.maps.InfoWindow();
//     const hidden = document.createElement('div');
//     map = new google.maps.Map(hidden);

//     const request = {
//         placeId: `${locationId}`,
//         fields: ['ALL'],
//     };

//     const service = new google.maps.places.PlacesService(map);

//     service.getDetails(request, (results, status) => {
//         if (status === google.maps.places.PlacesServiceStatus.OK) {
//             const starsBlocks = document.querySelectorAll('[data-reviews-stars-xxx]');
//             const countBlocks = document.querySelectorAll('[data-reviews-count-xxx]');

//              //Announcement bar reviews stars
//             if (starsBlocks.length > 0) {
//                 for (const starsBlock of starsBlocks) {
//                     setTimeout(() => {
//                         starsBlock.setAttribute('style', `width: ${results.rating * 10 * 2}%;`);
//                     }, 1000);
//                 }
//             }
//              //Announcement bar reviews count
//             if (countBlocks.length > 0) {
//                 for (const countBlock of countBlocks) {
//                     countBlock.innerHTML = results.user_ratings_total;
//                 }
//             }

//             //Reviews sections reviews
//             const reviewsWrappers = document.querySelectorAll('[data-x-reviews-wrapper]');

//             if (reviewsWrappers.length > 0)
//                 for (const reviewsWrapper of reviewsWrappers) {
//                     const swiperWrapper = reviewsWrapper.querySelector('[data-x-swiper-wrapper]');
//                     for (const review of results.reviews) {

//                         swiperWrapper.innerHTML += `
//                             <div class="swiper-slide">
//                                 <div class="slide__message">${review.text}</div>
//                                 <div class="slide__user">${review.author_name}</div>
//                                 <div class="slide__rating">
//                                     <div class="slide__stars">
//                                         <div class="stars-active">★★★★★</div>
//                                         <div class="stars-items" style="width: ${review.rating * 10 * 2}%;">★★★★★</div>
//                                     </div>
//                                     ${review.rating}/5
//                                     <a href="https://www.google.com/search?q=mascolori&oq=mascolori&gs_lcrp=EgZjaHJvbWUqCQgAECMYJxiKBTIJCAAQIxgnGIoFMg0IARAuGK8BGMcBGIAEMgYIAhBFGDwyBggDEEUYPDIGCAQQRRg8MgYIBRBFGDwyBggGEEUYPDIGCAcQRRg80gEIODUyOGowajeoAgCwAgA&sourceid=chrome&ie=UTF-8#lrd=0x47c434b263cfd523:0xd42be8595265340a,1,,,," target="_blank" class="review-link">Google</a>
//                                 </div>
//                             </div>
//                         `;
//                     }
//                 }
//             }
//     });
// }

// const loadGMaps = () => {
//     const script = document.createElement("script");
//     script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=initMap`;
//     script.defer = true;
//     script.async = true;
//     document.head.appendChild(script);
// }

// loadGMaps();

function checkAndRemoveElement() {
    var spanElements = document.querySelectorAll('.announcement__inner a');
    spanElements.forEach(function (spanElement) {
        if (window.innerWidth > 768 && spanElement.innerText.trim() === "★★★★★ reviews") {
            spanElement.parentNode.removeChild(spanElement);
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {
    checkAndRemoveElement();
});

window.addEventListener('resize', function () {
    checkAndRemoveElement();
});

function updateProductVariantPrices() {
    const select = document.querySelector('#product_select');
    const priceElement = document.getElementById('product-variant-price');

    if (!select || !priceElement) return;

    // Function to update price display based on selected variant
    function updatePriceDisplay(selectedOption) {
        if (!selectedOption) return;

        const variantPrice = selectedOption.getAttribute('data-pm-variant-price');
        const variantComparePrice = selectedOption.getAttribute('data-pm-variant-compare-price');

        // Clear the price element and rebuild it properly
        priceElement.innerHTML = variantPrice;

        if (variantComparePrice && variantComparePrice.trim() !== '') {
            // Calculate discount
            const currentPriceValue = parseFloat(variantPrice.replace(/[^\d,.-]/g, '').replace(',', '.'));
            const comparePriceValue = parseFloat(variantComparePrice.replace(/[^\d,.-]/g, '').replace(',', '.'));

            if (comparePriceValue > currentPriceValue) {
                const discountPercent = Math.round(((comparePriceValue - currentPriceValue) / comparePriceValue) * 100);
                // Try to get sale text from theme translations
                const saleText = document.querySelector('.product-card__discount[data-sale-text]')?.getAttribute('data-sale-text') || 'off';

                priceElement.innerHTML = `${variantPrice}
                        <span class="product-card__price-old">${variantComparePrice}</span>
                        <span class="product-card__discount" data-sale-text="${saleText}">${discountPercent}% ${saleText}</span>`;
            }
        }
    }

    const options = select.querySelectorAll('[data-pm-variant-id]');
    options.forEach(option => {
        option.addEventListener('click', function () {
            if (option.classList.contains('available')) {
                updatePriceDisplay(option);
            }
        });
    });
}

function updateCartPricesWithDiscounts() {
    // Function to update cart prices when quantity changes
    function updateCartItemPrices() {
        const cartProducts = document.querySelectorAll('[data-cart-popup-product]');

        cartProducts.forEach(cartProduct => {
            const priceElement = cartProduct.querySelector('.price[data-product-price]');
            const quantityInput = cartProduct.querySelector('[cart-counter-quantity]');

            if (!priceElement || !quantityInput) return;

            // Watch for quantity changes
            const observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                        // Quantity changed, update the price display
                        setTimeout(() => {
                            updateSingleCartItemDiscount(cartProduct);
                        }, 100);
                    }
                });
            });

            observer.observe(quantityInput, {
                attributes: true,
                attributeFilter: ['value']
            });
        });
    }

    function updateSingleCartItemDiscount(cartProduct) {
        const priceElement = cartProduct.querySelector('.price[data-product-price]');
        const quantityInput = cartProduct.querySelector('[cart-counter-quantity]');

        if (!priceElement || !quantityInput) return;

        const quantity = parseInt(quantityInput.value) || 1;
        const unitPrice = parseFloat(priceElement.getAttribute('data-product-price'));

        // Check if there are existing discount elements
        const existingOldPrice = priceElement.querySelector('.product-card__price-old');
        const existingDiscount = priceElement.querySelector('.product-card__discount');

        if (existingOldPrice && existingDiscount) {
            // Get the original compare price from the data or calculate it
            const discountText = existingDiscount.textContent.trim();
            const discountMatch = discountText.match(/(\d+)%/);

            if (discountMatch) {
                const discountPercent = parseInt(discountMatch[1]);
                const compareAtPrice = Math.round(unitPrice / (1 - discountPercent / 100));

                // Update old price with new quantity
                existingOldPrice.textContent = formatPrice(compareAtPrice * quantity);
            }
        }
    }

    function formatPrice(cents) {
        // Simple price formatting - you might need to adjust this based on your currency format
        return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }

    // Initialize the cart price monitoring
    if (document.querySelector('[data-cart-popup-product]')) {
        updateCartItemPrices();
    }

    // Also monitor for cart updates (when cart is refreshed)
    const cartContainer = document.getElementById('cartProductsBlock');
    if (cartContainer) {
        const cartObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'childList') {
                    // Cart was updated, reinitialize price monitoring
                    setTimeout(() => {
                        updateCartItemPrices();
                    }, 200);
                }
            });
        });

        cartObserver.observe(cartContainer, {
            childList: true,
            subtree: true
        });
    }
}


